import { MAX_WIDTH_LOWER_WIDTH } from '../../base-ui/Resolutions';
import { theme } from '../../theme/theme';
import styled from '@emotion/styled';

export const ResponsivePaddingLayoutContainer = styled.div`
	display: flex;
	flex-direction: column;
	block-size: 100%;
	padding-block: ${theme.paddings.sm};
	padding-inline: ${theme.paddings.xxl};

	@media ${MAX_WIDTH_LOWER_WIDTH} {
		padding-block: ${theme.paddings.xs};
		padding-inline: ${theme.paddings.xxs};
	}
`;
